import axios from 'axios';

const PUSHER_ENDPOINT = process.env.VUE_APP_CD_PUSHER_ENDPOINT;

export const sendToCustomerDisplay = async (subdomain, terminalId, payload) => {
  try {
    const channel = `${subdomain}_${terminalId}_cd`;
    const body = {
      channel,
      event: 'cd-update',
      data: payload
    };
    await axios.post(PUSHER_ENDPOINT, body, { withCredentials: false });
    return true;
  } catch (error) {
    console.error('[CustomerDisplay] POST failed', error);
    return false;
  }
};
